import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PortalModal from '../../common/PortalModal';
import { authFetch, BILLING_API_URL, SITE } from '../../utils/auth';
import '../../../css/partner/OnboardingWelcome.css';

export default function OnboardingStripe() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ open: false, title: '', message: '', variant: 'info' });

  function showError(message) {
    setModal({ open: true, title: 'Stripe Setup', message, variant: 'error' });
  }

  async function setupStripe() {
    setLoading(true);

    try {
      const response = await authFetch(
        BILLING_API_URL + '/connect/stripe/start/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Site': SITE,
          },
          body: JSON.stringify({ site: SITE }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        showError(data.detail || 'Unable to start Stripe onboarding. Please try again in a moment.');
      } else if (data.url) {
        window.location.href = data.url;
      } else {
        showError('Stripe onboarding could not start. Please try again in a moment.');
      }
    } catch (err) {
      console.error(err);
      showError('Unable to start Stripe onboarding. Please try again in a moment.');
    }

    setLoading(false);
  }

  async function verifyStripeConnection() {
    setLoading(true);

    try {
      const response = await authFetch(
        BILLING_API_URL + '/connect/stripe/complete/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Site': SITE,
          },
          body: JSON.stringify({ site: SITE }),
        }
      );
      const data = await response.json();

      if (!response.ok) {
        showError(data.detail || 'Stripe onboarding is not complete yet. Please finish Stripe setup.');
        return;
      }

      navigate('/onboarding/complete');
    } catch (err) {
      console.error(err);
      showError('Unable to verify Stripe onboarding. Please try again in a moment.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='onboarding-stripe'>
      <PortalModal open={modal.open} title={modal.title} variant={modal.variant} onClose={() => setModal({ ...modal, open: false })}>
        <p>{modal.message}</p>
      </PortalModal>

      <h1>Set Up Your Payout Account</h1>

      <p className='mt-4'>
        South Central Development uses Stripe Connect to pay commissions.
      </p>

      <ol>
        <li>Create your Stripe account.</li>
        <li>Verify your identity.</li>
        <li>Add your bank account information.</li>
        <li>Start earning commissions.</li>
      </ol>

      <div className='card p-4 mt-4'>
        <h5>Important</h5>

        <p>
          You must complete Stripe onboarding before commissions can be paid.
        </p>
      </div>

      <div className='actions'>
        <button
          className='btn btn-success'
          onClick={setupStripe}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Connect Stripe Account'}
        </button>

        <button
          className='btn btn-primary'
          onClick={verifyStripeConnection}
          disabled={loading}
        >
          I&apos;ve Already Connected Stripe
        </button>
      </div>
    </div>
  );
}
